import { action, observable } from 'mobx';
import apiCaller from '../../utils/api-caller';

class CmsLaundryServiceStore {
  @observable data = [];
  @observable laundryServiceOptions = [];
  @observable laundryService = null;

  @action getData() {
    return apiCaller.CmsLaundryServices.get().then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.data = resp.data;
        }
      }
    })
  }

  @action getOptions() {
    const languageCode = window.localStorage.getItem('lang') || 'en';
    return apiCaller.CmsLaundryServices.getByLanguageCode(languageCode).then(resp => {
      if (resp) {
        if (resp.length > 0) {
          let typeOptions = [];
          resp.map(type => {
            typeOptions.push({
              label: type.name,
              value: type.name
            });
            return type;
          });

          this.laundryServiceOptions = typeOptions;
          this.laundryService = typeOptions[0].value;
        } else {
          this.laundryServiceOptions = [];
          this.laundryService = null;
        }
      } else {
        this.laundryServiceOptions = [];
        this.laundryService = null;
      }
    })
  }

  @action initCreate(activeLanguages) {
    const getDataByIdZero = this.data.find(fi => fi.id === 0);
    if (!getDataByIdZero) {
      let newData = {
        'id': 0,
        'sort': 0,
        'laundryServiceLanguages': []
      };

      activeLanguages.map(lang => {
        newData.laundryServiceLanguages.push({
          'id': 0,
          'laundryServiceId': 0,
          'languageId': lang.id,
          'name': ''
        });

        return lang;
      });

      this.data.push(newData);
    }
  }

  @action create() {
    const request = this.data.find(fi => fi.id === 0);
    return apiCaller.CmsLaundryServices.create(request);
  }

  @action update(id) {
    const request = this.data.find(fi => fi.id === id);
    return apiCaller.CmsLaundryServices.update(id, request);
  }

  @action delete(id) {
    return apiCaller.CmsLaundryServices.delete(id);
  }

  @action cancel() {
    this.getData();
  }

  @action setsort(id, value) {
    let item = this.data.find(fi => fi.id === id);
    if (item) {
      item.sort = value;
    }
  }

  @action setname(id, langId, value) {
    let item = this.data.find(fi => fi.id === id);
    if (item) {
      let lang = item.laundryServiceLanguages.find(fi => fi.languageId === langId);
      if (lang) {
        lang.name = value;
      }
    }
  }

  @action setlaundryService(value) {
    this.laundryService = value;
  }

  @action resetData() {
    this.laundryService = null;
    this.laundryServiceOptions = [];
  }
}

export default new CmsLaundryServiceStore();